import { getLocalStorageItem } from './localstorage';

export function getCookie(cname: string) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function getBetaStatus() {
  if (getCookie('betaStatus')) {
    return getCookie('betaStatus');
  }
}

const DEFAULT_API_HOST = 'https://apis.relume.io/';
export function getApiHost(): string {
  if (
    typeof window === 'undefined' ||
    window == null ||
    window.location.origin === 'null'
  ) {
    // The figma extension runs in a fake JS vm (background thread)
    // and on a data url origin (page thread)
    return DEFAULT_API_HOST;
  }
  const lsDebugUrl = getLocalStorageItem('debugUrl');
  if (lsDebugUrl) {
    return lsDebugUrl;
  }
  if (getCookie('debugUrl')) {
    return getCookie('debugUrl');
  }
  if (getBetaStatus()) {
    return 'https://staging-apis.relume.io/';
  }
  return DEFAULT_API_HOST;
}
